module.exports = __webpack_public_path__ + "img/enerman-etsol-440x200.e1d8af47.svg";